export const fontSizes = {
  // Home page
  homeTitle: {
    xxs: '10rem',
    xs: '10rem',
    sm: '12rem',
    md: '18rem',
    lg: '18rem',
    xl: '18rem',
    xxl: '22rem',
  },
  homeSubTitle: {
    xxs: '1.4rem',
    xs: '1.8rem',
    sm: '2.2rem',
    md: '2.4rem',
    lg: '2.6rem',
    xl: '2.8rem',
    xxl: '3rem',
  },
  homeCitate: {
    xxs: '0.7rem',
    xs: '0.8rem',
    sm: '0.9rem',
    md: '0.8rem',
    lg: '0.8rem',
    xl: '0.9rem',
    xxl: '1.1rem',
  },
  homeTech: {
    xxs: '0.8rem',
    xs: '0.9rem',
    sm: '1.1rem',
    md: '1.1rem',
    lg: '1.1rem',
    xl: '1.3rem',
    xxl: '1.6rem',
  },

  // Contact page
  contactTitle: {
    xxs: '2rem',
    xs: '3rem',
    sm: '5rem',
    md: '7rem',
    lg: '9rem',
    xl: '10rem',
    xxl: '12rem',
  },
  contactInfo: {
    xxs: '0.9rem',
    xs: '1rem',
    sm: '1rem',
    md: '0.9rem',
    lg: '1rem',
    xl: '1.2rem',
    xxl: '1.2rem',
  },

  // About / Parallax page
  parallaxBetween: {
    xxs: '0.8rem',
    xs: '0.9rem',
    sm: '1.2rem',
    md: '1.4rem',
    lg: '1.5rem',
    xl: '1.6rem',
    xxl: '1.8rem',
  },
  parallaxShort: {
    xxs: '1.2rem',
    xs: '1.6rem',
    sm: '2rem',
    md: '2.3rem',
    lg: '2.4rem',
    xl: '2.7rem',
    xxl: '3rem',
  },

  // Resume page
  resumeH4: {
    xxs: '0.7rem',
    xs: '0.8rem',
    sm: '1.0rem',
    md: '1.2rem',
    lg: '1.4rem',
    xl: '1.6rem',
    xxl: '1.6rem',
  },
  resumeH6: {
    xxs: '0.5rem',
    xs: '0.5rem',
    sm: '0.8rem',
    md: '0.9rem',
    lg: '0.95rem',
    xl: '1rem',
    xxl: '1rem',
  },

  // Projects page
  projectDescription: {
    xxs: '0.5rem',
    xs: '0.5rem',
    sm: '0.6rem',
    md: '0.7rem',
    lg: '0.7rem',
    xl: '0.9rem',
    xxl: '1.1rem',
  },

  // Project video page
  videoBody2: {
    xs: '0.5rem',
    sm: '0.8rem',
    md: '0.7rem',
    lg: '0.9rem',
    xl: '1rem',
  },

  // Topbar / Menu
  menu: {
    xxs: '1.2rem',
    xs: '1.6rem',
    sm: '2rem',
    md: '2.3rem',
    lg: '2.4rem',
    xl: '2.7rem',
    xxl: '3rem',
  },

  // Footer
  footer: {
    xxs: '0.5rem',
    xs: '0.5rem',
    sm: '0.8rem',
    md: '0.9rem',
    lg: '1rem',
    xl: '1.2rem',
    xxl: '1.2rem',
  },

  // Description carousel container
  carouselH6: {
    xxs: '0.5rem',
    xs: '0.7rem',
    sm: '0.8rem',
    md: '0.9rem',
    lg: '0.95rem',
    xl: '1rem',
    xxl: '1rem',
  },
  carouselH4: {
    xxs: '0.6rem',
    xs: '0.7rem',
    sm: '1rem',
    md: '1.2rem',
    lg: '1.4rem',
    xl: '1.8rem',
    xxl: '2rem',
  },
};
